import { FC } from 'react';
import { ListSidebarPortal } from '../../../../../DesktopScripts/reactSrc/modules/list/components/ListSidebar/ListSidebarPortal';
import { ControlGroupSection } from '../../../../components/ControlGroup';
import { ListSidebarHeader } from '../../components/ListSidebar/ListSidebarHeader';
import { ListSidebarHeaderCloseButton } from '../../components/ListSidebar/ListSidebarHeaderCloseButton';
import { ListLoadingPlaceholderSidebarItem } from './ListLoadingPlaceholderSidebarItem';

const MIN_FIELDS_COUNT = 10;
const MAX_FIELDS_COUNT = 15;

function ListLoadingPlaceholderSidebarInner() {
	const formFieldsCount = Math.random() * (MAX_FIELDS_COUNT - MIN_FIELDS_COUNT) + MIN_FIELDS_COUNT;

	return (
		<>
			<ListSidebarHeader>
				<ListSidebarHeaderCloseButton disabled />
			</ListSidebarHeader>
			<div
				style={{
					padding: '12px',
				}}
			>
				<ControlGroupSection>
					{Array.from({ length: formFieldsCount }).map((_, index) => (
						<ListLoadingPlaceholderSidebarItem key={index} />
					))}
				</ControlGroupSection>
			</div>
		</>
	);
}

export const ListLoadingPlaceholderSidebar: FC = () => {
	return (
		<ListSidebarPortal>
			<ListLoadingPlaceholderSidebarInner />
		</ListSidebarPortal>
	);
};
